module.exports = __webpack_public_path__ + "static/media/Fazako.536f0cbf.png";